import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import FontAwesome from 'react-fontawesome';
import * as perm from '../../permission';

class SortBy extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.renderSortDirSymbol = this.renderSortDirSymbol.bind(this);
  }

  renderSortDirSymbol(value) {
    if (this.props.sortedBy == value) {
      return (<FontAwesome name={"sort-alpha-" +  this.props.sortedByDir} />);
    }
  }

  render() {
    return (
      <div className="btn-group btn-group-justified" role="group">
        {this.props.sortOptions.map((item, index) => {
          return (
            <span key={index} className={classNames("sort-option btn btn-small btn-default btn-secondary", {
                'btn-default': this.props.sortedBy !== item.value,
                'btn-info': this.props.sortedBy === item.value,
              })}
              onClick={() => {
                this.props.updateCB(item.value)
              }}>
              {item.label}
              &nbsp;
              {this.renderSortDirSymbol(item.value)}
            </span>);
        })}
      </div>
    )
  }
}

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
SortBy.propTypes = {
  sortedBy: PropTypes.string,
  sortedByDir: PropTypes.string,
  sortOptions: PropTypes.array.isRequired,
  updateCB: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    currentUser: state.users.currentUser,
  };
}


export default connect(
  mapStateToProps,
  null
)(SortBy);



/** WEBPACK FOOTER **
 ** ./src/components/common/SortBy.js
 **/